import * as React from 'react';

const SvgFacebook = (props) => (
  <svg
    width={8}
    height={20}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M2.042 18v-7.508H0V7.79h2.042V5.48C2.042 3.666 3.25 2 6.028 2c1.126 0 1.958.105 1.958.105L7.92 4.629s-.848-.008-1.775-.008c-1.002 0-1.163.45-1.163 1.194V7.79H8l-.131 2.703H4.982V18h-2.94Z'
      fill='#fff'
    />
  </svg>
);

export default SvgFacebook;
